//1 = light blue, 2 = blue, 3 = yellow, 4 = red

export const scimitar = [
    0, 0, 0, 0, 0, 0, 0, 0, 0, 5, 2, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 5, 2, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 5, 2, 2, 0, 
    0, 0, 0, 0, 0, 0, 0, 5, 2, 2, 4, 0, 
    0, 0, 0, 0, 0, 0, 2, 2, 2, 4, 4, 0, 
    0, 0, 0, 0, 0, 2, 2, 4, 4, 4, 0, 0, 
    0, 0, 0, 0, 2, 2, 4, 0, 0, 0, 0, 0, 
    0, 0, 0, 3, 2, 4, 0, 0, 0, 0, 0, 0, 
    0, 0, 3, 0, 3, 0, 0, 0, 0, 0, 0, 0, 
    5, 3, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 
    1, 3, 3, 3, 3, 0, 0, 0, 0, 0, 0, 0, 
    1, 1, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0,
]